import type { CraftQuery } from "@/content-hub/theme/themes/types";

/**
 * Returns a Craft node’s mounted DOM element, or `null` if the node is missing
 * or not yet mounted. Wraps `query.node(id).getDOM()` in try/catch so callers
 * (e.g. share URL builders) stay safe when the tree is in flux.
 */
export function getCraftNodeDom(
  query: CraftQuery,
  nodeId: string
): HTMLElement | null | undefined {
  try {
    return query.node(nodeId).getDOM() ?? undefined;
  } catch {
    return null;
  }
}
